import {Component, Input} from '@angular/core';
import {NgIf, NgOptimizedImage} from "@angular/common";
import {LoaderComponent} from "../loader/loader.component";

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [
    NgOptimizedImage,
    NgIf,
    LoaderComponent
  ],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss'
})
export class ButtonComponent {
  @Input() loading: boolean = false;
  @Input() icon: string = '';
  @Input() text: string = '';
  @Input() variant: 'primary' | 'plain' | 'danger' = 'primary';

  get isPrimary(): boolean {
    return this.variant === 'primary';
  }

  get isPlain(): boolean {
    return this.variant === 'plain';
  }

  get isDanger(): boolean {
    return this.variant === 'danger';
  }
}
